module.exports = __webpack_public_path__ + "static/img/xiaoguotu.5e8313b5.png";